"use strict";
exports.__esModule = true;
var commonpassword_1 = require("./commonpassword");
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var cmpts;
        (function (cmpts) {
            var password;
            (function (password) {
                var MostCommonPassword = commonpassword_1["default"].MostCommonPassword;
                /**
                 * Verify is password is strong enough.
                 *
                 * @param input
                 * @returns {boolean}
                 */
                password.scorePassword = function (input) {
                    var score = 0;
                    if (typeof input !== 'string' || !input) {
                        return score;
                    }
                    var letters = {};
                    for (var i = 0; i < input.length; i++) {
                        letters[input[i]] = (letters[input[i]] || 0) + 1;
                        score += 5.0 / letters[input[i]];
                    }
                    var variations = 0;
                    variations += /\d/.test(input) ? 1 : 0;
                    variations += /[a-z]/.test(input) ? 1 : 0;
                    variations += /[A-Z]/.test(input) ? 1 : 0;
                    variations += /\W/.test(input) ? 1 : 0;
                    score += variations * 10 - 10;
                    score += input.length > 14 ? (input.length - 14) * 3 : 0;
                    return score;
                };
                var mostcommonpassword = MostCommonPassword.getPasswordArray();
                password.length_check = function (input) {
                    return input.length >= 8;
                };
                //check if password has uppercase and lowercase letters
                password.letters_check = function (input) {
                    return /^(?=.*[a-z])(?=.*[A-Z])/.test(input);
                };
                //check if password has digits(0-9)
                password.digits_check = function (input) {
                    return /^(?=.*\d)/.test(input);
                };
                //check if password has special charactor
                password.specialCharactor_check = function (input) {
                    return /^(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])/.test(input);
                };
                password.dictionary_wordnotused_check = function (input) {
                    return mostcommonpassword.indexOf(input) === -1;
                };
                var PasswordChecker = /** @class */ (function () {
                    function PasswordChecker(checkFunction, errorMessage) {
                        this.check = checkFunction;
                        this.errorMessage = function () {
                            return errorMessage;
                        };
                    }
                    return PasswordChecker;
                }());
                password.PasswordChecker = PasswordChecker;
                password.checkers = [
                    new PasswordChecker(password.length_check, "Please make password at least 8 characters in length"),
                    new PasswordChecker(password.letters_check, "Please add at least one" +
                        " uppercase and one lowercase letter"),
                    new PasswordChecker(password.digits_check, "Please add at lease 1 digit"),
                    new PasswordChecker(password.specialCharactor_check, "Please add a special character"),
                    new PasswordChecker(password.dictionary_wordnotused_check, "Password is too easy to guess")
                ];
            })(password = cmpts.password || (cmpts.password = {}));
        })(cmpts = r6.cmpts || (r6.cmpts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.cmpts.password;
//# sourceMappingURL=password.js.map


// WEBPACK FOOTER //
// ./app/components/password/app/js/logic/password.js